import { QueryClient } from '@tanstack/react-query'

// Query keys factory centralizado
export const queryKeys = {
  pacientes: {
    all: ['pacientes'] as const,
    list: (search?: string) => ['pacientes', 'list', search] as const,
    detail: (dni: string) => ['pacientes', 'detail', dni] as const,
  },
  turnos: {
    all: ['turnos'] as const,
    list: (params?: Record<string, unknown>) => ['turnos', 'list', params] as const,
    detail: (id: string) => ['turnos', 'detail', id] as const,
  },
  historia: {
    list: (dni: string) => ['historia', dni] as const,
  },
  odontograma: {
    detail: (dni: string) => ['odontograma', dni] as const,
  },
  finanzas: {
    reporte: () => ['finanzas', 'reporte'] as const,
    gastosFijos: () => ['finanzas', 'gastos-fijos'] as const,
    transacciones: (params?: object) => params ? ['finanzas', 'transacciones', params] as const : ['finanzas', 'transacciones'] as const,
    resumenCategorias: (mes: number, anio: number) => ['finanzas', 'resumen-categorias', mes, anio] as const,
  },
  marketing: {
    all: ['marketing'] as const,
    eventos: (estado?: string) => ['marketing', 'eventos', estado] as const,
    mensajes: () => ['marketing', 'mensajes'] as const,
    manuales: (params?: object) => ['marketing', 'manuales', params] as const,
    kpis: () => ['marketing', 'kpis'] as const,
    comunicaciones: (filtros?: object) => ['marketing', 'comunicaciones', filtros] as const,
    comunicacionesKpis: () => ['marketing', 'comunicaciones', 'kpis'] as const,
    configRecordatorios: () => ['marketing', 'config', 'recordatorios'] as const,
    listas: () => ['marketing', 'listas'] as const,
  },
  laboratorios: {
    all: ['laboratorios'] as const,
    proveedores: () => ['laboratorios', 'proveedores'] as const,
    ordenes: (pacienteDni?: string) => pacienteDni ? ['laboratorios', 'ordenes', { pacienteDni }] as const : ['laboratorios', 'ordenes'] as const,
    orden: (id: string) => ['laboratorios', 'orden', id] as const,
  },
  insumos: {
    all: () => ['insumos'] as const,
    kpis: () => ['insumos', 'kpis'] as const,
    alertas: () => ['insumos', 'alertas'] as const,
    movimientos: (id: string) => ['insumos', 'movimientos', id] as const,
    escandallo: (procedimientoId: string) => ['insumos', 'escandallo', procedimientoId] as const,
  },
  procedimientos: {
    all: () => ['procedimientos'] as const,
  },
  catalogo: {
    all: () => ['catalogo', 'procedimientos'] as const,
    escandallo: (id: string) => ['catalogo', 'escandallo', id] as const,
    configuracion: () => ['catalogo', 'configuracion'] as const,
    profesionales: (id: string) => ['catalogo', 'profesionales', id] as const,
  },
  sedes: {
    all: () => ['sedes'] as const,
  },
  profesionales: {
    all: () => ['profesionales'] as const,
  },
  firma: {
    list: (dni: string) => ['firma', 'documentos', dni] as const,
  },
  presupuestos: {
    list: (dni: string) => ['presupuestos', dni] as const,
    detail: (dni: string, id: string) => ['presupuestos', dni, id] as const,
    global: (params?: object) => ['presupuestos', 'global', params] as const,
  },
}

// Re-export QueryClient for convenience (used in providers.tsx)
export { QueryClient }
